import { EnterpriseState } from './types'

const initialState: EnterpriseState = {
  enterprise: undefined,
  isLoading: false,
  error: undefined
}

export default initialState
